// extracted by mini-css-extract-plugin
module.exports = {"container":"WindowCenteredContainer_container__V610n"};